import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import {
  IntlProvider,
  addLocaleData,
  FormattedDate as IntlFormattedDate,
  FormattedTime as IntlFormattedTime,
  FormattedRelative as IntlFormattedRelative,
  FormattedNumber as IntlFormattedNumber,
  FormattedPlural as IntlFormattedPlural,
  FormattedMessage as IntlFormattedMessage,
  FormattedHTMLMessage as IntlFormattedHTMLMessage,
} from 'react-intl';
import omit from 'lodash/omit';
import DefaultRenderComponent from './default-component';

let RenderComponent = DefaultRenderComponent;

const wrapIntlComponent = (IntlComponent) => {
  const defaultRender = (txt, props) =>
    createElement(RenderComponent, props, txt);

  const FormattingComponent = (props = {}) =>
    <IntlComponent {...omit(props, 'renderProps')}>
      {txt => (props.children || defaultRender).call(props, txt, props.renderProps)}
    </IntlComponent>;

  FormattingComponent.propTypes = {
    ...IntlComponent.propTypes,
    renderProps: PropTypes.object,
  };

  return FormattingComponent;
};

export const FormattedDate = wrapIntlComponent(IntlFormattedDate);
export const FormattedTime = wrapIntlComponent(IntlFormattedTime);
export const FormattedRelative = wrapIntlComponent(IntlFormattedRelative||<></>);
export const FormattedNumber = wrapIntlComponent(IntlFormattedNumber);
export const FormattedPlural = wrapIntlComponent(IntlFormattedPlural);
export const FormattedMessage = wrapIntlComponent(IntlFormattedMessage);
export const FormattedHTMLMessage = wrapIntlComponent(IntlFormattedHTMLMessage||<></>);

export const setI18nComponent = (NewRenderComponet) => {
  RenderComponent = NewRenderComponet;
};

export const getI18nComponent = () => RenderComponent;

export { IntlProvider, addLocaleData };
